var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePaymentFeq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 2.50004H13V0.833374H11.3333V2.50004H4.66667V0.833374H3V2.50004H2.16667C1.72464 2.50004 1.30072 2.67564 0.988155 2.9882C0.675595 3.30076 0.5 3.72468 0.5 4.16671V15.8334C0.5 16.2754 0.675595 16.6993 0.988155 17.0119C1.30072 17.3244 1.72464 17.5 2.16667 17.5H6.33333V15.8334H2.16667V6.66671H13.8333V7.50004H15.5V4.16671C15.5 3.72468 15.3244 3.30076 15.0118 2.9882C14.6993 2.67564 14.2754 2.50004 13.8333 2.50004ZM16.0833 11.125L15.25 11.9584L13.5417 10.2917L14.375 9.45837C14.5417 9.28337 14.825 9.27504 15.0167 9.45837L16.0833 10.525C16.2417 10.6917 16.2417 10.9584 16.0833 11.125ZM8 15.7834L13.0583 10.7334L14.7667 12.4L9.71667 17.5H8V15.7834Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePaymentFeq);
export default __webpack_public_path__ + "static/media/change-payment-feq.625964ef28c62708176ab555068651b8.svg";
export { ForwardRef as ReactComponent };